import React from "react";
import { Box } from "@mui/material";
import InexButton from "../../InexButton";
import ListEvenements from "./evenements/ListEvenements";
import { useGetProductsByCategoryQuery } from "../../../store/api/product";
import { useGetEventsQuery } from "../../../store/api/event";

const EvenementsMainBlock = ({ ...props }) => {
	const { data } = useGetEventsQuery({ activites: 0, authToken: null, offset: 0, limit: 20 });

	const products = React.useMemo(() => {
		return data?.items || null;
	}, [data]);

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
			}}
		>
			<ListEvenements products={products} />
			<a href={"https://praticiens.inexplore.com"}>
				<InexButton
					textWithGradient={false}
					disableBackground={true}
					text={"Inexploré Praticiens : découvrir le projet"}
					sx={{
						marginTop: 4,
						padding: 3.5,
						width: "250px",
						backgroundColor: (theme) => theme.palette.lightgrey,
						transition: "border-color 0.3s, background 0.3s, color 0.3s,",
						"& > p": {
							color: (theme) => theme.palette.secondary.main,
							transition: "color 0.3s,",
						},
						"&:hover": {
							backgroundColor: (theme) => theme.palette.secondary.main,
							border: "none",
							"& > p": {
								color: "white",
							},
						},
					}}
				/>
			</a>
		</Box>
	);
};

export default EvenementsMainBlock;
